function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.48605 9.35097C9.48605 7.20694 10.798 5.35363 12.7255 4.3434V18.6539H16.6129V3.53666H20.5003V18.6539H24.3876V4.3434C26.3151 5.35363 27.6271 7.20694 27.6271 9.35097V18.6539H31.5145V9.35097C31.5145 4.21258 26.8739 0.0480804 21.1481 0.0480804H15.965C10.2392 0.0480804 5.59868 4.21258 5.59868 9.35097V18.6539H9.48605V9.35097ZM36.5599 24.897L35.6934 22.5712C35.337 21.6191 34.349 20.9796 33.2314 20.9796H3.87367C2.75605 20.9796 1.76801 21.6191 1.41167 22.5712L0.545108 24.897C-0.00560192 26.4014 1.24159 27.9567 3.00711 27.9567V36.0968C3.00711 36.7363 3.59021 37.2596 4.3029 37.2596H6.89447C7.60716 37.2596 8.19026 36.7363 8.19026 36.0968V27.9567H28.9229V36.0968C28.9229 36.7363 29.506 37.2596 30.2187 37.2596H32.8102C33.5229 37.2596 34.106 36.7363 34.106 36.0968V27.9567C35.8715 27.9567 37.1187 26.4014 36.5599 24.897Z",
  fill: "white"
});

function SvgEntrancehall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntrancehall);
export default __webpack_public_path__ + "static/media/entrancehall.31138db71b521a75664980e3c47dfd6c.svg";
export { ForwardRef as ReactComponent };